// extracted by mini-css-extract-plugin
export var root = "theme-icon-module--root--7ca29";